import { Card, Col, Container, Row} from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './Labs.css'


const Labs = () => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <main className='labs'>
            <Container>
                <Row xs={1}>
                    <Col className='my-5'>
                        <Row className='justify-content-center align-items-center'>
                            <Col sm={'12'} md={'6'}>
                                <img data-aos='fade-down' src='./img/img7.png' className='img-fluid' alt='Foto 1' />
                            </Col>
                            <Col sm={'12'} md={'6'}>
                                <Card className='card1' data-aos='fade-left'>
                                  <p>
                                        Los estándares de hoy en día pasan por unos laboratorios de alto nivel. 
                                        Para ello deben cumplir todas las Normativas Reglamentarias. Nuestro 
                                        trabajo consiste en asegurar en todo momento la Excelencia desde nuestro 
                                        sector. Para ello, ofrecemos servicios de Temperaturas Controladas, 
                                        Fitosanitarios, Calibración, Telecomunicaciones, Sanitarios de Frío 
                                        Industrial, Ventilación o Calidad del Aire.
                                    </p>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Labs